import $ from 'jquery'

const scrollToBlock = (block, offset) => {
  const win = $(window)
  const animSpeed = 650
  const page = $('html,body')
  let isWP8;

  if (navigator.userAgentData) {
    let uaList = navigator.userAgentData.brands;
    let auBrands = [];
    for (const element of uaList) {
      auBrands.push(element.brand);
    }

    let brandsString = auBrands.join();
    if (/MSIE 10.*Touch/i.test(brandsString)) {
      isWP8 = true;
    } else {
      isWP8 = false;
    }

  } else {
    isWP8 = /MSIE 10.*Touch/.test(navigator.userAgent);
  }

  const { top } = $(block).offset();

  if (isWP8) {
    win.scrollTop(top)
  } else {
    page.animate({
      scrollTop: top - (offset || 0),
    }, animSpeed)
  }
}

const renderTabFaq = (
  tabs = document.querySelector('.faq-tabs'),
) => {
  const tabLink = $(tabs).find('.faq-tabs__list .box')
  const mainTabLink = $(tabs).find('.main-lvl .box')
  const subTab = $(tabs).find('.sub-lvl')
  const subLink = $(tabs).find('.sub-lvl .box')
  const tabsContent = $(tabs).find('.faq-tabs__content')
  const contactLink = $(tabs).find('.btn-open__form')

  mainTabLink.on('click', () => {
    subTab.removeClass('active')
    subLink.removeClass('active')
  })

  contactLink.on('click', function () {
    scrollToBlock($(this).parents('.two-cols').next(), $('.site-header').outerHeight())
  })

  tabLink.on('click', function () {
    $([$(this)[0], $($(this).data('tab'))[0]]).addClass('active').siblings('.active').removeClass('active')
    const subLinkActive = subLink.filter('.active')
    if (subLinkActive && subLinkActive.length) {
      scrollToBlock(subTab.find('.sub-lvl').filter('.active'), $('.site-header').outerHeight())
    } else {
      scrollToBlock(tabsContent, $('.site-header').outerHeight())
    }
  })
}

export default renderTabFaq
